import { pathJoin } from 'x1-base/utils';
import { castArray as lo_castArray } from 'es-toolkit/compat';

export function useUrlUtils() {

    const $config = useRuntimeConfig();

    function getFullUrl(path?: Nilable<string | string[]>): Nullable<string> {
        let url: Nullable<string> = null;

        if (path) {
            path = lo_castArray(path);
            const baseURL = $config.public.environment.homeUrl;
            url = pathJoin(baseURL, ...path);
        }
        
        return url;
    }

    return {
        getFullUrl
    };
}
